import ChartDataLabels from 'chartjs-plugin-datalabels';
import NexlabChartPalette from './filament-chart-palette';
import NexlabResponsiveDensity from './filament-chart-responsive';
import NexlabLineLegend from './filament-chart-line-legend';

window.filamentChartJsPlugins ??= [];
window.filamentChartJsPlugins.push(ChartDataLabels);

// after ChartDataLabels so its options object exists to be thinned out
window.filamentChartJsPlugins.push(NexlabResponsiveDensity);

// the palette reads the themed text colour Filament writes onto options.color, and
// it must see the datalabels options object after density has finished with it
window.filamentChartJsPlugins.push(NexlabChartPalette);
window.filamentChartJsPlugins.push(NexlabLineLegend);
